import { Grid, GridItem, GridRow } from 'components/Grid';
import { ISharedTemplateProps } from 'templates/TemplateMapper/types';
import { IntroTextContext } from './components/IntroTextContext';
export interface IIntroText {
  description?: string | null;
  title?: string | null;
  super?: string | null;
  titleTag?: string | null;
}

export const IntroText = ({
  super: superText,
  titleTag,
  title,
  description,
}: IIntroText & ISharedTemplateProps) => {
  return (
    <div className="relative break-words w-full">
      <Grid>
        <GridRow columns={16}>
          <GridItem colStart={4} colSpan={10} className="text-center px-1/10">
            <IntroTextContext
              superText={superText}
              title={title}
              titleTag={titleTag}
              description={description}
            />
          </GridItem>
        </GridRow>
      </Grid>
    </div>
  );
};
